import i18next from 'i18next';
import { format, parseISO } from 'date-fns';
import { enUS, ptBR, es } from 'date-fns/locale';

const locales = {
  en: enUS,
  pt: ptBR,
  es: es,
};

export const formatDate = (date, formatStr = 'P') => {
  const currentLocale = i18next.language || 'en';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  
  // Default format patterns based on locale
  const defaultFormats = {
    en: 'MM/dd/yy',
    pt: 'dd/MM/yy',
    es: 'dd/MM/yy',
  };

  // Use provided format or default based on locale
  const finalFormat = formatStr === 'P' ? defaultFormats[currentLocale] : formatStr;

  return format(dateObj, finalFormat, {
    locale: locales[currentLocale],
  });
};

export const formatTime = (date) => {
  const currentLocale = i18next.language || 'en';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  
  const timeFormats = {
    en: 'h:mm aaa',  // 12-hour with AM/PM
    pt: 'HH:mm',     // 24-hour
    es: 'HH:mm',     // 24-hour
  };

  return format(dateObj, timeFormats[currentLocale], {
    locale: locales[currentLocale],
  });
};

export const formatDateTime = (date) => {
  const currentLocale = i18next.language || 'en';
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  
  // Format patterns for date and time based on locale
  const dateFormats = {
    en: 'MM/dd/yy',
    pt: 'dd/MM/yy',
    es: 'dd/MM/yy',
  };

  const timeFormats = {
    en: 'h:mm aaa',  // 12-hour with AM/PM
    pt: 'HH:mm',     // 24-hour
    es: 'HH:mm',     // 24-hour
  };

  const formatString = `${dateFormats[currentLocale]} ${timeFormats[currentLocale]}`;
  
  return format(dateObj, formatString, {
    locale: locales[currentLocale],
  });
};
